export default "__VITE_ASSET__CX$A55Tw__"